import { Component, Inject, Input, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material";
import { UserBook } from "src/_models";
import { EventService } from "src/_services/event.service";

type UserBookProps = {
  providerId: string;
  sportId: string;
  eventId: string;
  marketId: string;
};

@Component({
  selector: "user-book",
  templateUrl: "./user-book.component.html",
  styleUrls: ["./user-book.component.scss"],
})
export class UserBookComponent implements OnInit {
  userBook: UserBook;
  userBookProps: UserBookProps;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private eventService: EventService
  ) {
    if (data.userBookInfo) {
      // this.betInfo = data.betInfo;
      console.log(data.userBookInfo);
      this.userBookProps = data.userBookInfo;
    }
  }

  ngOnInit() {
    if (this.userBookProps) {
      this.getUserBook();
    }
  }

  getUserBook() {
    try {
      this.eventService
        .getMarketRisk(
          this.userBookProps.providerId,
          this.userBookProps.sportId,
          this.userBookProps.eventId,
          this.userBookProps.marketId
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.userBook = res;
          }
        });
    } catch (err) {}
  }
}
